import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
})
export class FilterByPropertyPipe implements PipeTransform {
  transform<T>(items: T[], property: keyof T, value: any): T[] {
    if (!items || !property || value === undefined || value === null) {
      return items;
    }
    return items.filter((item) => item[property] === value);
  }
}
